import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';

@Component({
  selector: 'app-form-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class FormColorPickerComponent {
  @Input() field: Field;
  @Input() form: FormGroup;

  get formValue(): string {
    const value = this.form?.get(this.field?.name)?.value;
    return typeof value === 'string' ? value : '';
  }

  onChangeColor(color: string): void {
    if (!this.field?.name || !this.form) return;
    this.form.patchValue({ [this.field.name]: color });
  }
}
